/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Embed_Captions_IntroInputs */

const en_embed_captions_intro = /** @type {(inputs: Embed_Captions_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your video and caption file will be uploaded for processing. You will receive an email with a download link once the embed job is completed. Please contact support if you require assistance.`)
};

const fr_embed_captions_intro = /** @type {(inputs: Embed_Captions_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Votre video et votre fichier de sous-titres seront televerses pour traitement. Vous recevrez un e-mail avec un lien de telechargement une fois la tache terminee. Veuillez contacter le support si vous avez besoin d'aide.`)
};

const de_embed_captions_intro = /** @type {(inputs: Embed_Captions_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ihre Video- und Untertiteldatei werden zur Verarbeitung hochgeladen. Sobald die Einbettung abgeschlossen ist, erhalten Sie eine E-Mail mit einem Download-Link. Bei Fragen wenden Sie sich bitte an den Support.`)
};

const it_embed_captions_intro = /** @type {(inputs: Embed_Captions_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Il tuo video e il file dei sottotitoli verranno caricati per l'elaborazione. Riceverai un'e-mail con un link per il download una volta completato il processo di incorporamento. Contatta l'assistenza se hai bisogno di aiuto.`)
};

const ru_embed_captions_intro = /** @type {(inputs: Embed_Captions_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ваш видеофайл и файл с субтитрами будут загружены для обработки. После завершения процесса встраивания вы получите электронное письмо со ссылкой для скачивания. Если вам потребуется помощь, обратитесь в службу поддержки.`)
};

const es_embed_captions_intro = /** @type {(inputs: Embed_Captions_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Su archivo de video y subtítulos se cargará para su procesamiento. Recibirá un correo electrónico con un enlace de descarga una vez finalizada la inserción. Si necesita ayuda, póngase en contacto con el equipo de soporte.`)
};

const zh_cn2_embed_captions_intro = /** @type {(inputs: Embed_Captions_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`您的视频和字幕文件将被上传进行处理。嵌入完成后，您将收到一封包含下载链接的电子邮件。如有任何疑问，请联系客服。`)
};

const ja_embed_captions_intro = /** @type {(inputs: Embed_Captions_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`動画とキャプションファイルは処理のためにアップロードされます。埋め込みが完了すると、ダウンロードリンクを記載したメールが届きます。ご不明な点がございましたら、サポートまでお問い合わせください。`)
};

const hi_embed_captions_intro = /** @type {(inputs: Embed_Captions_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`आपकी वीडियो और कैप्शन फ़ाइल प्रोसेसिंग के लिए अपलोड कर दी गई है। एम्बेड प्रक्रिया पूरी होने पर आपको डाउनलोड लिंक वाला एक ईमेल प्राप्त होगा। सहायता के लिए कृपया सपोर्ट से संपर्क करें।`)
};

const pt_pt2_embed_captions_intro = /** @type {(inputs: Embed_Captions_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seu vídeo e arquivo de legenda serão enviados para processamento. Você receberá um e-mail com um link para download assim que a incorporação for concluída. Entre em contato com o suporte caso precise de ajuda.`)
};

/**
* | output |
* | --- |
* | "Your video and caption file will be uploaded for processing. You will receive an email with a download link once the embed job is completed. Please contact s..." |
*
* @param {Embed_Captions_IntroInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const embed_captions_intro = /** @type {((inputs?: Embed_Captions_IntroInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Embed_Captions_IntroInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_embed_captions_intro(inputs)
	if (locale === "de") return de_embed_captions_intro(inputs)
	if (locale === "it") return it_embed_captions_intro(inputs)
	if (locale === "ru") return ru_embed_captions_intro(inputs)
	if (locale === "es") return es_embed_captions_intro(inputs)
	if (locale === "zh-CN") return zh_cn2_embed_captions_intro(inputs)
	if (locale === "ja") return ja_embed_captions_intro(inputs)
	if (locale === "hi") return hi_embed_captions_intro(inputs)
	if (locale === "pt-PT") return pt_pt2_embed_captions_intro(inputs)
	return en_embed_captions_intro(inputs)
});